import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { Widget } from 'src/app/core/models/core.models';

@Component({
  selector: 'app-widget-settings-debug-chart-config',
  templateUrl: './widget-settings-debug-chart-config.component.html',
  styleUrls: ['./widget-settings-debug-chart-config.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class WidgetSettingsDebugChartConfigComponent {
  @Input() widget: Widget;
}
